import React from 'react'
import PropTypes from 'prop-types'
import { AnimatePresence, motion } from 'framer-motion'
import { useTranslation } from 'react-i18next'

export default function DemoBanner({ isVisible = false }) {
  const { t } = useTranslation()
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          key="demo-banner"
          className="pv2 ph3 bg-yellow bt f7 tc lh-title fixed left-0 bottom-0 right-0 shadow-3 z-999"
          style={{
            borderColor: '#E6D44F',
          }}
          initial={{
            y: 50,
          }}
          animate={{
            y: 0,
          }}
          exit={{
            y: 50,
            transition: {
              duration: 2.2,
            },
          }}
        >
          <strong>{t('demoBanner.headline')}</strong> {t('demoBanner.moreInfo')}{' '}
          <a className="link orange" href="https://wisehome.dk/kort-fortalt/">
            {t('demoBanner.contactUs')}
          </a>
          .
        </motion.div>
      )}
    </AnimatePresence>
  )
}

DemoBanner.propTypes = {
  isVisible: PropTypes.bool,
}
